import React, {useEffect, useState} from 'react';
import Icon from '../Icons/Icon';
import { classNames } from '../../Services/helpers';

const devices = {
    '8plus': {
        row: 'text-xs px-4 h-[20px]',
    },
    '11pro': {
        row: 'text-sm px-8 h-[44px]',
    },
}

const StatusBar = () => {
    const [device, setDevice] = useState(null);

    useEffect(() => {
        setDevice(window.localStorage.getItem('statusBar'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.localStorage.getItem('statusBar')]);

    if (!device) {
        return null;
    }

    const classes = devices[device] ?? null;

    if (!classes) {
        console.log('Invalid device: ', device);
        console.log('Valid devices: '+Object.keys(devices).join(', '));
        return null;
    }

    return <div className="container px-0 bg-white">
        <div className={classNames('flex justify-between w-full text-black fill-black', classes.row)}>
            <div className="w-1/2 flex justify-start items-center">
                4:20
            </div>
            <div className="w-1/2 flex justify-end items-center">
                <Icon theme="solid" icon="Wifi" className="mr-3" />
                <Icon theme="solid" icon="BatteryThreeQuarters" />
            </div>
        </div>
    </div>
}

export default StatusBar;
